module.exports = __webpack_public_path__ + "img/3.10545b3e.png";